import { changeMassStatusAction } from '../../redux/actions/tickets';

export const DEFAULT_PAGE_STATUSES = ['1', '3', '4'];

export const generateAccessMassDrop = (config) => {
  const access = config?.access ? config.access : {};
  const defaultMassActions = [
    {
      title: 'Change status',
      id: 1,
      defActionName: 'change_status',
    },
    {
      title: 'Mark as unread',
      id: 2,
      defActionName: 'unread_ticket',
    },
    {
      title: 'Close and lock',
      id: 3,
      defActionName: 'close_lock_ticket',
    },
    {
      title: 'Delete',
      id: 4,
      defActionName: 'delete_ticket',
    },
  ];

  return defaultMassActions?.filter((item) => Object.keys(access)
    .filter((item) => access[item])
    .includes(item.defActionName));
};

export const submitMassAction = (props) => {
  const { key, title, values } = props;

  switch (title.trim()) {
  case 'Change status':
    return changeMassStatusAction({ status: key, items: values });

  case 'Mark as unread':
    return changeMassStatusAction({ status: 4, items: values });

  case 'Delete':
    return changeMassStatusAction({ status: 5, items: values });

  case 'Close and lock':
    return changeMassStatusAction({ status: 6, items: values });

  default:
    break;
  }
};

/**
 * @name prepareConfirmBtnsText
 * @param title {String} - Заголовок события
 */
export const prepareConfirmBtnsText = ({ title }) => {
  switch (title) {
  case 'Change status':
    return {
      confirmBtnText: 'Change',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'Mark as unread':
    return {
      confirmBtnText: 'Mark as unread',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'Close and lock':
    return {
      confirmBtnText: 'Close and lock',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'Delete':
    return {
      confirmBtnText: 'Delete',
      cancelBtnText: 'Cancel',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};

export const ticketToolbar = [
  ['bold', 'italic', 'blockquote'],
  ['ul', 'ol'],
  ['hr'],
]
export const convertStringToHtml = (html) => `${html}`.replace(/<html>|<body>|<\/html>|<\/body>/g, '').trimStart().trimEnd().replace(/\r\n|\n|\r/gm, '<br />')
